/* eslint-disable arrow-body-style */
import React from 'react';
import { Translate } from 'react-redux-i18n';

import { enumPermissions } from '../data/permissions';

export default function Checkbox(props) {
  const {
    permissions = '', config = '', translate, inputsStateDisabled,
    billetOff, inputsLabel, opicName, companyTag,
  } = props;

  const InputCheckbox = ({ permission }) => {
    const label = typeof (permission.label) === 'function'
      ? permission.label(companyTag)
      : permission.label;
    return (
      <div className="form-check" style={permission.checkContainerStyle || {}}>
        <input
          checked={permissions[permission.id]}
          type="checkbox"
          className="form-check-input checkbox-permissions"
          id={permission.id}
          onChange={e => props.onCheckBox(e.target.checked, permission.id)}
          disabled={inputsStateDisabled[permission.id]}
        />
        <p className="permission-text">
          {translate ? <Translate value={label} /> : label}
          {' '}
          {permission.id === enumPermissions.OPIC_CODE && (<span className="permission-text">{opicName}</span>)}
          {inputsLabel[permission.id] && inputsLabel[permission.id] !== '' && (
            <span className="permission-label">
              <br />
              {inputsLabel[permission.id]}
            </span>
          )}
        </p>
      </div>
    );
  };

  return config.map((item) => {
    return (
      <div className="col-6" key={item.name}>
        <p style={{
          fontSize: '20px',
          fontWeight: 'bold',
        }}
        >
          <Translate value={item.name} />
        </p>

        {
          item.permissions.map((permission) => {
            if (permission.id === 'purchaseBankSlip' && billetOff) return '';
            if (permission.id === 'purchaseEstimate' && companyTag === 'nortel') return '';
            if (permission.id === 'managerEmail' && companyTag !== 'nortel') return '';
            if (permission.id === 'purchaseCreditStock' && companyTag !== 'nortel') return '';
            if (permission.id === 'purchaseCreditMinDeliveryDate' && companyTag !== 'nortel') return '';
            if (permission.id === 'purchaseBankSlipStock' && companyTag !== 'nortel') return '';
            if (permission.id === 'purchaseBankSlipMinDeliveryDate' && companyTag !== 'nortel') return '';
            if (permission.id === 'purchasePaymentGateway' && companyTag !== 'chile') {
              return '';
            }
            return (
              <InputCheckbox permission={permission} key={permission.id} />
            );
          })
        }
      </div>
    );
  });
}
